// @flow

import React from 'react';
import KeepeekMedia from '../../../common/KeepeekMedia';
import type { MarketingTemplate } from '../../../../types/marketingType';

type Props = {
  data: MarketingTemplate
}

function TemplateBlock({ data }: Props) {
  return (
    <div className="block-template">
      <div className="title">{data.title}</div>
      <div className="block-container">
        {
          data.blocks
            .sort((a, b) => a.position - b.position)
            .map(block => (
              <div key={block.id} className="block">
                <div className="data-container">
                  <div className="block-title">{block.title}</div>
                  <div className="block-description">{block.description}</div>
                </div>
                <KeepeekMedia keepeekId={block.image.keepeekId} />
              </div>
          ))
        }
      </div>
    </div>
  );
}

export default TemplateBlock;
